import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const MENUS_LIST = "menus_list";
export const MENUS_SIMPLE_LIST = "menus_simple_list";
export const CREATE_MENU = "create_menu";
export const UPDATE_MENU = "update_menu";
export const UPDATE_MENU_STATUS = "UPDATE_MENU_STATUS";
export const DELETE_MENU = "delete_menu";
export const GET_MENU_DETAILS = "get_menu_details";
export const CLEAR_MENU_ERRORS = "clearMenuErrors";

// mutation types
export const SET_MENU_ERROR = "setMenuError";
export const REMOVE_MENU_ERRORS = "removeMenuErrors";

const state = {
    errors: null
};


const actions = {
    [MENUS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/menus?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_MENU_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_MENU_ERROR, response.errors);
                });
        });
    },
    [MENUS_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/menussimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
    [GET_MENU_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getmenudetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_MENU_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_MENU_ERROR, response.errors);
                });
        });
    },
    [CREATE_MENU](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createmenu", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_MENU_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_MENU_ERROR, response.errors);
                });
        });
    },
    [UPDATE_MENU](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatemenu", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_MENU_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_MENU_ERROR, response.errors);
                });
        });
    },
    [UPDATE_MENU_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatemenustatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_MENU_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_MENU_ERROR, response.errors);
                });
        });
    },
    [DELETE_MENU](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletemenu", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_MENU_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_MENU_ERROR, response.errors);
                });
        });
    },
    [CLEAR_MENU_ERRORS](context) {
        context.commit(REMOVE_MENU_ERRORS);
    },
};

const mutations = {
    [SET_MENU_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_MENU_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
